import React, { useEffect, useState, useCallback } from "react";
import { getStaffListApi } from "../../api/staffService";
import Button from "../../utils/Buttons";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
import StatusBadge from "../Shared/StatusBadge";
import ActionIconButton from "../Shared/ActionIconButton";
import { FaEye, FaEdit } from "react-icons/fa";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";
function StaffList(props) {
  const userId = props.userId;
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const loadStaff = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getStaffListApi({
        page: currentPage,
        pageSize: itemsPerPage,
      });
      const data = Array.isArray(res?.data) ? res.data : [];
      setStaff(data);
      setTotalItems(res?.pagination?.totalItems || data.length);
    } catch (error) {
      console.log(error);
      setStaff([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage]);
  useEffect(() => {
    loadStaff();
  }, [loadStaff]);

  if (loading) {
    return <FullPageLoader text="Loading staff..." />;
  }
  const handleAddStaff = () => {
    navigate("/staff/add", { state: { userId } });
  };
  const handleEdit = (staffId) => {
    navigate(`/staff/edit/${staffId}`, { state: { userId: userId, staffId } });
  };
  const handleView = (staffId) => {
    navigate(`/staff/view/${staffId}`, { state: { userId: userId, staffId } });
  };

  return (
    <div className="container p-4 np-staff-page">
      <div className="card p-3">
        {staff.length === 0 ? (
          <EmptyState
            action={
              <Button
                text="Add Staff"
                icon={<FiPlus size={15} />}
                className="btn btn-primary"
                onClick={handleAddStaff}
              />
            }
          />
        ) : (
          <>
        <div className="d-flex justify-content-end align-items-center mb-2">
          <Button
            text="Add Staff"
            icon={<FiPlus size={15} />}
            className="btn btn-primary"
            onClick={handleAddStaff}
          />
        </div>
        <table className="table table-bordered table-hover ">
          <thead className="bg-light">
            <tr>
              <th className="text-dark fw-bold">#</th>
              <th className="text-dark fw-bold">Name</th>
              <th className="text-dark fw-bold">Email</th>
              <th className="text-dark fw-bold">Status</th>
              <th className="text-dark fw-bold">Role</th>

              <th className="text-dark fw-bold">Action</th>
            </tr>
          </thead>
          <tbody>
            {staff.map((item, index) => (
                <tr key={item._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{item.fullName}</td>
                  <td>{item.email}</td>
                  <td>
                    <StatusBadge status={item.status} />
                  </td>
                  <td>{item.role}</td>

                  <td className="text-center">
                    <ActionIconButton
                      icon={<FaEye />}
                      label="View"
                      variant="view"
                      onClick={() => handleView(item._id)}
                    />
                    <ActionIconButton
                      icon={<FaEdit />}
                      label="Edit"
                      variant="edit"
                      onClick={() => handleEdit(item._id)}
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
          </>
        )}
      </div>
      {staff.length > 0 && <Pagination
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
      />}
    </div>
  );
}
export default StaffList;
